"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoCompleteInputSchema = void 0;
exports.default = AutoCompleteInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const zod_1 = require("zod");
exports.autoCompleteInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.string().min(1, 'Required'),
    notRequired: zod_1.z.string(),
});
function AutoCompleteInput({ name, label, dataTestId = 'auto_complete', formHelperText, options = [], disabled = false, }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const fieldId = (0, react_1.useId)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    const helperMessage = (error === null || error === void 0 ? void 0 : error.message) || formHelperText;
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { error: !!error, sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.Autocomplete, Object.assign({ id: `auto_complete_${fieldId}`, "data-test-id": `form_input_${dataTestId}`, options: options }, field, { value: (field.value || null), onChange: (_, newValue) => field.onChange(newValue || ''), renderInput: (params) => (0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({ error: Boolean(error), label: label }, params, { required: true })), disabled: disabled })), helperMessage && ((0, jsx_runtime_1.jsx)(material_1.FormHelperText, { "data-test-id": `${dataTestId}_helper_message`, children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (error === null || error === void 0 ? void 0 : error.message) || formHelperText }) }))] }));
}
//# sourceMappingURL=AutoCompleteInput.js.map